import envJson from "../env.json";
import { normalizeMongoId } from "./utils";

// Helpers for resolving per-property GRE banner URLs from list/detail payloads.

// Fallback CloudFront base when API does not return property_media_base_url.
export const DEFAULT_PROPERTY_MEDIA_BASE_URL =
  envJson.PROPERTY_MEDIA_BASE_URL ||
  `${String(envJson.ADMIN_BASE_URL || envJson.BASE_URL || "").replace(/\/$/, "")}/property/`;

// Joins media base URL with banner filename for API/list responses.
export function buildPropertyMediaUrl(baseUrl, filename) {
  if (!filename || typeof filename !== "string" || !filename.trim()) {
    return null;
  }

  const mediaBase = baseUrl || DEFAULT_PROPERTY_MEDIA_BASE_URL;
  if (!mediaBase) {
    return null;
  }

  const normalizedBase = String(mediaBase).replace(/\/?$/, "/");
  return `${normalizedBase}${filename}`;
}

// Picks gre_banner_url or builds URL from gre_banner + property media base.
export function resolveGrePropertyBannerUrl(property, baseUrl) {
  if (!property) {
    return null;
  }

  if (property.gre_banner_url) {
    return property.gre_banner_url;
  }

  const filename = property.gre_banner;
  const mediaBase =
    baseUrl || property.base_url || property.property_media_base_url || "";

  return buildPropertyMediaUrl(mediaBase, filename);
}

// Finds a property record across cached GRE/property pools by id.
export function findPropertyInPools(propertyId, propertyPools = []) {
  const normalizedId = normalizeMongoId(propertyId);
  if (!normalizedId) {
    return null;
  }

  for (const pool of propertyPools) {
    if (!Array.isArray(pool)) {
      continue;
    }

    const match = pool.find(
      (item) =>
        normalizeMongoId(item?.property_id ?? item?._id) === normalizedId,
    );

    if (match) {
      return match;
    }
  }

  return null;
}

// Resolves banner URL for a property id from pools or optional fallback record.
export function resolveGreBannerForPropertyId(
  propertyId,
  propertyPools = [],
  options = {},
) {
  const { baseUrl, fallbackProperty, mediaBaseUrl } = options;
  const match =
    findPropertyInPools(propertyId, propertyPools) || fallbackProperty || null;
  const resolvedBase =
    baseUrl ||
    match?.base_url ||
    match?.property_media_base_url ||
    mediaBaseUrl ||
    DEFAULT_PROPERTY_MEDIA_BASE_URL;

  return resolveGrePropertyBannerUrl(match, resolvedBase);
}
